import { Injectable } from '@angular/core';
import { Apollo } from "apollo-angular";
import Organization from "../../interfaces/organization";
import { BehaviorSubject, Subscription } from "rxjs";
import { nav_search_organizations } from "../../side-nav/cw-search/graphql/navSearchOrganizations";
import {CERTIFICATED_OUTLETS, CREATE_CERTIFICATED_OUTLET} from "./graphql/add-certificated-outlet";
import CertificatedOutlet from "../../interfaces/certificated-outlet";

@Injectable({
  providedIn: 'root'
})
export class AddCertificatedOutletService {

  private _organizations: Organization[] = [];
  private organizations = new BehaviorSubject<Organization[]>(this._organizations);
  public organizations$ = this.organizations.asObservable();

  private _loading = false;
  private loading = new BehaviorSubject<boolean>(false);
  public loading$ = this.loading.asObservable();

  private certificatedOutlets: CertificatedOutlet[] = []
  private outletsSub: Subscription

  constructor(public apollo: Apollo) {
    this.outletsSub = this.apollo.query({query: CERTIFICATED_OUTLETS}).subscribe(({data}:any) => {
      this.certificatedOutlets = data.certificatedOutlets
      this.outletsSub?.unsubscribe()
    })
  }

  private _setOrganizations(organizations: Organization[]) {
    this._organizations = organizations;
    this.organizations.next(this._organizations);
  }
  private _setLoading(loading: boolean) {
    this._loading = loading;
    this.loading.next(this._loading);
  }
  public searchOrganizations(query: string) {
    let sub:Subscription;
    this._setLoading(true);
    sub = this.apollo.query({query: nav_search_organizations, variables: {searchLike: `%${query}%`, search:query, limit: 10, page:1 }}).subscribe(({data})=>{
        if(data?.search_organizations){
          let filteredOrganizations: Organization[] = []
          data.search_organizations.data.forEach((org:any) => {
            let foundOutlet = this.certificatedOutlets.find((outlet:CertificatedOutlet) => org.id == outlet.organization.id)
            let hasInvestorTag = org.entity.entity_types.find((type:any) => type.type.name == "Investor")
            if(!foundOutlet && hasInvestorTag){
              filteredOrganizations.push(org)
            }
          })
          this._setOrganizations(filteredOrganizations);
        }
        this._setLoading(false);
        sub?.unsubscribe();
    });
  }
  public saveCertificatedOutlet(org:Organization) {
    return this.apollo.mutate({mutation:CREATE_CERTIFICATED_OUTLET, variables:{organization_id: org.id}});
  }
}
